export default __webpack_public_path__ + "static/media/2380.f4d39782.jpg";